import { Box, ScrollView, View } from '@rbilabs/universal-components';
import { useWindowDimensions } from 'react-native';

import { useIsDesktopLargeBreakpoint } from 'hooks/use-media-query';
import {
  WEB_APP_MAX_WIDTH,
  WEB_APP_MAX_WIDTH_DESKTOP_LARGE,
  WEB_APP_MODAL_CONTENT_MAX_WIDTH,
} from 'utils/constants';

export const LayoutContainer = Box.withConfig(
  ({ isModal, isFullContainer = false }: { isModal?: boolean; isFullContainer?: boolean }) => {
    const dimension = useWindowDimensions();
    const isDesktop = useIsDesktopLargeBreakpoint();
    const maxWidth = isDesktop
      ? isModal
        ? WEB_APP_MODAL_CONTENT_MAX_WIDTH
        : WEB_APP_MAX_WIDTH_DESKTOP_LARGE
      : WEB_APP_MAX_WIDTH;

    const totalPaddingX = (dimension.width - maxWidth) / 2;
    let paddingX = totalPaddingX > 0 ? totalPaddingX : '$4';
    if (isFullContainer) {
      paddingX = 0;
    }

    return {
      _web: {
        flex: 1,
      },
      paddingX,
      flexGrow: 1,
    };
  }
);

export const InnerLayout = Box.withConfig({
  _web: {
    flex: 1,
  },
  paddingX: {
    md: '$16',
    lg: '$32',
    base: '0',
  },
  paddingY: '$4',
  flexGrow: 1,
});

export const ScrollViewStyled = ScrollView.withConfig({
  flex: 1,
  overflowX: 'hidden',
  contentContainerStyle: {
    flexGrow: 1,
  },
});

export const ViewStyled = View.withConfig({
  flex: 1,
  overflowX: 'hidden',
});
